import React, { Component } from 'react';
//import Breadcrumb from "../common/breadcrumb";
import OtpInput from 'react-otp-input';
import { Link } from 'react-router-dom';
import PinInput from 'react-pin-input';
import Form from 'react-validation/build/form';
import Input from 'react-validation/build/input';
import CheckButton from 'react-validation/build/button';
import AuthService from '../services/auth.service';
import ApiService from '../services/api.service';
import { lab } from 'color-convert';
import FullPageLoader from '../../components/layouts/full-loader/main';
import CountryCodePicker from '../common/CountryCodePicker';

class Login2 extends Component {
  constructor(props) {
    super(props);
    this.handleLogin = this.handleLogin.bind(this);
    //this.onChangePhone = this.onChangePhone.bind(this);
    this.onChangePassword = this.onChangePassword.bind(this);

    this.state = {
      showWelcome: true,
      showSms: false,
      showPassword: false,
      bgColor1: 'white',
      bgColor2: '#white',
      bgColor3: '#white',
      step1: '1_',
      step2: '2.',
      step3: '3.',
      otp: '',
      opacity: '1',
      opacity2: '0.2',
      opacity3: '0.2',
      value: '',
      phone: '',
      country_code: '+51',
      password: '',
      showForm: true,
      isLoading: false
    };
  }

  componentWillMount() {
    //document.body.style = `background: linear-gradient(318.35deg, #1A73DB -41.04%, #59D1EB 122.69%);`;
    localStorage.removeItem('login-message');
    setTimeout(function() {
      var loader = document.querySelector('.loader-wrapper');
      if (loader) loader.style = 'display: none';
    }, 2000);

    this.checkOpenWeb();

    if (AuthService.getCurrentUser()) {
      this.props.history.push('/welcome');
      window.location.reload();
    }
  }

  checkOpenWeb() {
    ApiService.checkOpenWeb().then(
      res => {
        if (res && res.status === 'success') {
          if (res.data.option_value === 'NO') {
            this.setState({
              showForm: false
            });
          }
        } else if (res && res.status === 'error') {
          // 👈 FIX AQUÍ
          this.setState({
            showForm: false
          });
        } else {
          // 👈 opcional: por si res viene undefined
          this.setState({
            showForm: false
          });
        }
      },
      error => {
        const resMessage =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();

        // 👈 buena práctica: manejar error también
        this.setState({
          showForm: false
        });
      }
    );
  }

  onChangePhone = e => {
    let val = e.target.value;
    let max = 15;
    let vale_lenght = val.toString().length;
    if (vale_lenght <= max) {
      this.setState({
        phone: val
      });
    }
  };

  onChangeCountryCode = (code) => {
    this.setState({ country_code: code });
  };

  onChangePassword(e) {
    this.setState({
      password: e.target.value
    });
  }

  onChange = value => {
    this.setState({ pin_code: value });
  };

  onClear = () => {
    this.setState({
      value: ''
    });
    this.pin.clear();
  };

  handleChange = otp => this.setState({ otp });

  btnWelcome() {
    if (!this.state.phone) {
      return true;
    }

    let data_user = {
      cell_phonenumber: this.state.phone,
      country_code: this.state.country_code
    };

    this.setState({ isLoading: true }); // Mostrar loader

    ApiService.sendPhone(data_user).then(
      res => {
        this.setState({ isLoading: false }); // Ocultar loader

        if (res) {
          if (res.status === 'success') {
            this.setState({
              showWelcome: !this.state.showWelcome,
              showSms: !this.state.showSms,
              bgColor1: 'white',
              bgColor2: 'white',
              bgColor3: 'white',
              step1: '1.',
              step2: '2_',
              step3: '3.',
              opacity: '0.2',
              opacity2: '1',
              opacity3: '0.2'
            });
          } else {
            this.props.history.push('/unauthorized');
          }
        }
      },
      error => {
        this.setState({ isLoading: false }); // Ocultar loader en error también

        const resMessage =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();

        this.setState({
          loading: false,
          message: resMessage
        });
      }
    );
  }

  btnSms() {
    this.setState({
      showSms: !this.state.showSms,
      showPassword: !this.state.showPassword,
      bgColor1: 'white',
      bgColor2: 'white',
      bgColor3: 'white',
      step1: '1.',
      step2: '2.',
      step3: '3_',
      opacity: '0.2',
      opacity2: '0.2',
      opacity3: '1'
    });
  }

  btnStep1() {
    return false;
    /*this.setState({
            showWelcome:true,
            showSms:false,
            showPassword:false,
            bgColor1: "white",
            bgColor2: "white",
            bgColor3: "white",
            step1: '1_',
            step2: '2.',
            step3: '3.',
            opacity:'1',
            opacity2:'0.2',
            opacity3:'0.2',
        })*/
  }

  btnStep2() {
    return false;
    /*this.setState({
            showWelcome:false,
            showSms:true,
            showPassword:false,
            bgColor1: "white",
            bgColor2: "white",
            bgColor3: "white",
            step1: '1.',
            step2: '2_',
            step3: '3.',
            opacity:'0.2',
            opacity2:'1',
            opacity3:'0.2',
        })*/
  }

  btnStep3() {
    return false;
    /*this.setState({
            showWelcome:false,
            showSms:false,
            showPassword:true,
            bgColor1: "white",
            bgColor2: "white",
            bgColor3: "white",
            step1: '1.',
            step2: '2.',
            step3: '3_',
            opacity:'0.2',
            opacity2:'0.2',
            opacity3:'1',
        })*/
  }

  btnPassword() {}

  handleLogin(e) {
    //document.getElementsByClassName("page-loader")[0].style.display = "flex";

    AuthService.login(
      this.state.phone,
      this.state.password,
      this.state.pin_code,
      this.state.country_code
    ).then(
      res => {
        if (res && res.status == 'success') {
          //document.getElementsByClassName("page-loader")[0].style.display = "none";
          localStorage.removeItem('login-message');
          this.props.history.push('/welcome');
          //window.location.reload();
        } else {
          //document.getElementsByClassName("page-loader")[0].style.display = "none";
          localStorage.setItem('login-message', res.message);
          this.props.history.push('/unauthorized');
        }
        //this.props.history.push("/dashboard");
        //window.location.reload();
      },
      error => {
        //document.getElementsByClassName("page-loader")[0].style.display = "none";

        const resMessage =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();

        this.setState({
          loading: false,
          message: resMessage
        });
      }
    );
  }

  componentDidMount() {
    document.body.classList.remove('dark');

    // Forzamos que se muestre el loader 3 segundos
    this.setState({ isLoading: true });
    setTimeout(() => {
      this.setState({ isLoading: false });
    }, 3000); // 3000ms = 3 segundos
  }

  render() {
    document.body.classList.remove('dark');

    return (
      <>
        {/* Mostramos el loader si isLoading está en true */}
        {this.state.isLoading && (
          <FullPageLoader isLoading={this.state.isLoading} />
        )}

        <div className="sup-content-login">
          {/* <Breadcrumb title={'Login'}/> */}

          {/* Login section */}
          <div className="container container-sms-login">
            <Form
              className="theme-form form-login"
              ref={c => {
                this.form = c;
              }}
              onSubmit={e => {
                e.preventDefault();
              }}
            >
              <div className="logo-cruz" style={{ display: 'grid' }}>
                <img
                  src="/assets/images/logo_cruz.png"
                  className="img-logo-cruz"
                  alt="Logo"
                />
                <span className="ver-login-ui">Uiuid</span>
              </div>

              {/* Aviso */}
              {this.state.showForm === false && (
                <div>
                  <h2 className="title-div h2-welcome-text">¡Aviso!</h2>
                  <h2 className="title-div h2-welcome-text">
                    La Página se encuentra cerrada.
                  </h2>
                </div>
              )}

              {/* Bienvenido */}
              {this.state.showWelcome && this.state.showForm && (
                <div>
                  <h2 className="title-div h2-welcome-text">BIENVENIDO</h2>
                  <div className="form-group form-group-login">
                    <CountryCodePicker
                      value={this.state.country_code}
                      onChange={this.onChangeCountryCode}
                      phone={this.state.phone}
                      onPhoneChange={this.onChangePhone}
                      disabled={this.state.isLoading}
                    />
                  </div>
                  <a onClick={() => this.btnWelcome()}>
                    <img
                      src="/assets/images/boton_off.png"
                      className="img-btn-step"
                      onMouseOver={e =>
                        (e.currentTarget.src = '/assets/images/boton_hover.png')
                      }
                      onMouseOut={e =>
                        (e.currentTarget.src = '/assets/images/boton_off.png')
                      }
                      alt="Botón"
                    />
                  </a>
                </div>
              )}

              {/* SMS */}
              {this.state.showSms && (
                <div>
                  <label htmlFor="phone" className="text-div">
                    TE ENVÍAMOS UN CÓDIGO AL WHATSAPP
                  </label>
                  <h2 className="title-div h2-code-text">INGRESALO AQUÍ</h2>
                  <div className="form-group form-group-login">
                    <PinInput
                      length={4}
                      focus
                      ref={p => (this.pin = p)}
                      type="numeric"
                      onChange={this.onChange}
                      min="0"
                      inputMode="number"
                      pattern="[0-9]*"
                    />
                  </div>
                  <a onClick={() => this.btnSms()}>
                    <img
                      src="/assets/images/boton_off.png"
                      className="img-btn-step"
                      onMouseOver={e =>
                        (e.currentTarget.src = '/assets/images/boton_hover.png')
                      }
                      onMouseOut={e =>
                        (e.currentTarget.src = '/assets/images/boton_off.png')
                      }
                      alt="Botón"
                    />
                  </a>
                </div>
              )}

              {/* Password */}
              {this.state.showPassword && (
                <div>
                  <label htmlFor="phone" className="text-div">
                    INGRESA TU
                  </label>
                  <h2 className="title-div h2-password-text">CONTRASEÑA</h2>
                  <div className="form-group form-group-login">
                    <Input
                      name="password"
                      type="password"
                      id="password"
                      className="form-control input-password"
                      placeholder="CONTRASEÑA"
                      value={this.state.password}
                      onChange={this.onChangePassword}
                      inputMode="numeric"
                      pattern="[0-9]*"
                    />
                  </div>
                  <a
                    style={{ background: 'transparent', border: 'none' }}
                    onClick={() => this.handleLogin()}
                  >
                    <img
                      src="/assets/images/boton_off.png"
                      className="img-btn-step"
                      onMouseOver={e =>
                        (e.currentTarget.src = '/assets/images/boton_hover.png')
                      }
                      onMouseOut={e =>
                        (e.currentTarget.src = '/assets/images/boton_off.png')
                      }
                      alt="Botón"
                    />
                  </a>
                </div>
              )}

              {/* Steps */}
              <div
                className="container-btn-steps"
                style={{ width: '100%', textAlign: 'center' }}
              >
                <div className="btn-steps">
                  <a
                    className="btn btn-step"
                    style={{
                      opacity: this.state.opacity,
                      color: this.state.bgColor1
                    }}
                    onClick={() => this.btnStep1()}
                  >
                    {this.state.step1}
                  </a>
                  <a
                    className="btn btn-step"
                    style={{
                      opacity: this.state.opacity2,
                      color: this.state.bgColor2
                    }}
                    onClick={() => this.btnStep2()}
                  >
                    {this.state.step2}
                  </a>
                  <a
                    className="btn btn-step"
                    style={{
                      opacity: this.state.opacity3,
                      color: this.state.bgColor3
                    }}
                    onClick={() => this.btnStep3()}
                  >
                    {this.state.step3}
                  </a>
                </div>
              </div>
            </Form>
          </div>

          {/* Imagen derecha */}
          <div className="image-right">
            <img src="/assets/images/plant_login.png" alt="Imagen Login" />
          </div>
        </div>
      </>
    );
  }
}

export default Login2;
